import React from 'react';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Download, ChevronDown, FileSpreadsheet, FileText, FileJson } from 'lucide-react';

/**
 * ExportMenu — the ONE export control used across every operator data surface
 * (Dashboard, Revenue, P&L, Expenses, …). Keeps the trigger button + the
 * CSV/PDF/JSON menu items visually identical everywhere.
 *
 * @param {(format: 'csv'|'pdf'|'json') => void} onExport
 * @param {Array<'csv'|'pdf'|'json'>} [formats]
 */
const FORMAT_META = {
  csv: { label: 'Export as CSV', Icon: FileSpreadsheet },
  pdf: { label: 'Export as PDF', Icon: FileText },
  json: { label: 'Export as JSON', Icon: FileJson },
};

export const ExportMenu = ({ onExport, formats = ['csv', 'pdf', 'json'], align = 'end', disabled = false }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button
        variant="ghost"
        className="gap-2 h-10 bg-white text-gray-700 shadow-[0_8px_24px_rgba(0,0,0,0.04)] hover:bg-white hover:shadow-[0_12px_32px_rgba(0,0,0,0.08)] transition-shadow"
        disabled={disabled}
        data-testid="export-menu-trigger"
      >
        <Download className="w-4 h-4" />
        <span className="hidden sm:inline">Export</span>
        <ChevronDown className="w-4 h-4" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align={align} className="border-0 rounded-xl shadow-[0_12px_32px_rgba(0,0,0,0.10)]">
      {formats.map((f) => {
        const meta = FORMAT_META[f];
        if (!meta) return null;
        const { label, Icon } = meta;
        return (
          <DropdownMenuItem
            key={f}
            onClick={() => onExport(f)}
            className="gap-2 cursor-pointer menu-item-label"
            data-testid={`export-option-${f}`}
          >
            <Icon className="w-4 h-4 text-gray-500" />
            {label}
          </DropdownMenuItem>
        );
      })}
    </DropdownMenuContent>
  </DropdownMenu>
);

export default ExportMenu;
